module.exports = __webpack_public_path__ + "media/img/video-75b703096c3bd4eb1888e34de467ab75.jpg";